import { html, customElement } from '@adobe/edex/ui/edex-lit';
import { EdexTagName, RoutePath } from '@adobe/edex/ui/shared/constants';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { BaseAuthElement } from '@adobe/edex/ui/components/base.element';
import { buildLink, getQueryParams, getSearchString } from '@adobe/edex/ui/shared/utils/routes';
import { IMS } from '@adobe/edex/ui/shared/config/ims';
import { router } from '../../config/router';
import './auth.scss';

@customElement(EdexTagName.auth)
export class AuthPage extends BaseAuthElement {
  get useLightDom() {
    return true;
  }

  static get properties() {
    return {
      ...super.properties,
    };
  }

  // https://jira.corp.adobe.com/browse/VULN-38175
  // The previous /javascript|vbscript/ substring check was case-sensitive (bypassed by
  // e.g. "JaVaScRiPt:") and missed other dangerous schemes (e.g. "data:"). Instead of
  // trying to blocklist every scheme, validate the final resolved URL against a
  // same-origin http(s) allowlist right before it's handed to window.location.replace.
  isSafeRedirectUrl(url: string) {
    try {
      const resolved = new URL(url, window.location.origin);
      return resolved.origin === window.location.origin && ['http:', 'https:'].includes(resolved.protocol);
    } catch (e) {
      return false;
    }
  }

  updated(changedProperties: Map<string, any>) {
    if (changedProperties.has('selfIsFulfilled')) {
      const query = getQueryParams(router.location.search);
      const queryLocation = query['backUrl']?.toString().split('?') || [];
      const redirectionURL = this.buildRedirectionURL(queryLocation);
      window.location.replace(this.isSafeRedirectUrl(redirectionURL) ? redirectionURL : RoutePath.landing);
    }
  }

  private buildRedirectionURL(queryLocation: string[]) {
    const path = queryLocation[0] || RoutePath.landing;
    const queryParams = getQueryParams(queryLocation[1] || '');
    const searchString = getSearchString(queryParams);
    const pathWithLocale = buildLink(path);
    const searchQueryParams = searchString ? `?${searchString}` : '';
    return `${pathWithLocale}${searchQueryParams}`;
  }

  render() {
    return html`
      <div id="auth-redirect-container">
        <h1>${$t('i18n.One_Moment_Please')}</h1>
        <p>${$t('i18n.You_are_being_redirected')}</p>
        <p>
          <a href=${RoutePath.landing}>${$t('i18n.If_not_redirected_in_num_seconds', { num: 5 })}</a>
        </p>
        <i aria-hidden="true" class="icon-spinner spin"></i>
      </div>
    `;
  }
}
